import ConfirmationDlg from "../../../../components/ConfirmationDlg";
import React, { useEffect, useState, useCallback } from "react";
import { useAuth } from "../../../../contexts/AuthContext.jsx";
import { renderImage } from "../../../../utils/helper.jsx";
import { toast } from "react-toastify";
import { location } from "../../../../api";
import NormalInput from "../../../../components/form/HorizontalNormalInput/index.jsx";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../components/card/card.jsx";
import { Form } from "react-bootstrap";

const permissions = {
  view: [
    {
      name: "Machine Online Status",
    },
    {
      name: "Machine Health",
    },
    {
      name: "Machine Uptime",
    },
    {
      name: "Machine Alert Status",
    },
    {
      name: "Alert Count",
    },
    {
      name: "Alert Details",
    },
    {
      name: "GINA Feature",
    },
    {
      name: "MACHINE PROFILES",
    },
  ],
  update: [
    {
      name: "Machine Online Status",
    },
    {
      name: "Machine Health",
    },
    {
      name: "Machine Uptime",
    },
    {
      name: "Machine Alert Status",
    },
    {
      name: "Alert Count",
    },
    {
      name: "Alert Details",
    },
    {
      name: "MACHINE PROFILES",
    },
  ],
  create: [
    {
      name: "Machine Online Status",
    },
    {
      name: "Machine Health",
    },
    {
      name: "Machine Uptime",
    },
    {
      name: "Machine Alert Status",
    },
    {
      name: "Alert Count",
    },
    {
      name: "Alert Details",
    },
    {
      name: "MACHINE PROFILES",
    },
  ],
  delete: [
    {
      name: "Machine Online Status",
    },
    {
      name: "Machine Health",
    },
    {
      name: "Machine Uptime",
    },
    {
      name: "Machine Alert Status",
    },
    {
      name: "Alert Count",
    },
    {
      name: "Alert Details",
    },
    {
      name: "MACHINE PROFILES",
    },
  ],
};
function ModalChangeRole({ open, onClose, onSubmit, row, customPermissions }) {
  const { getCompanyAccess } = useAuth();
  const [name, setName] = useState("");
  const [userRoleFeatureAccess, setUserRoleFeatureAccess] = useState([]);
  const [status, setStatus] = useState("");
  const [locations, setLocations] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [companyAccess, setCompanyAccess] = useState(false);
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [overviewPage, setOverviewPage] = useState("admin");
  const [renderKey, setRenderKey] = useState(0);
  const [checkboxStates, setCheckboxStates] = useState({});

  async function getLocations() {
    try {
      const res = await location.list("", true);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;

        setLocations(data);
        //console.log({ data });
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }
  const config = getCompanyAccess();
  useEffect(() => {
    setCompanyAccess(config);
    getLocations();
  }, []);

  const dashboard_features = [
    "Machine Online Status",
    "Machine Health",
    "Machine Uptime",
    "Machine Alert Status",
  ].filter((item) => {
    return config.includes(item);
  });
  const alert_features = ["Alert Count", "Alert Details", "Manual Alert Entry"].filter((item) => {
    return config.includes(item);
  });

  //const MPitem = config.includes("MACHINE PROFILES") ? "MACHINE PROFILES" : "";
  const MPitem = "MACHINE PROFILES";
  const Gina = config.includes("GINA Feature") ? "GINA Feature" : "";

  function filterAccesses(arr) {
    // check if arr is exist in userRoleFeatureAccess
    const filtered = companyAccess.filter((item) => {
      return arr.includes(item.name);
    });
    //console.log({ filtered });
    return filtered;
  }

  async function handleSubmit() {
    //validation
    let errors = [];
    if (!name) {
      errors.push("Enter role name");
    }
    if (errors.length > 0) {
      toast.error(errors.join("\n"));
      return;
    }
    onSubmit({
      name,
      userRoleFeatureAccess,
      accesses: selectedLocations,
      status,
      overviewPage,
    });
    if (!row) {
      clearFields();
    }
  }

  function clearFields() {
    setName("");
    setStatus("");
    setSelectedLocations([]);
    setOverviewPage("admin");
    setRenderKey(0);
    setCheckboxStates({});

    setUserRoleFeatureAccess(prev =>
      prev.map(ac => ({
        ...ac,
        can_view: false,
        can_create: false,
        can_update: false,
        can_delete: false
      }))
    );
  }
  async function handleClose() {
    clearFields();
    onClose();
  }

  function emptyFeatureAccess() {
    //generate default access
    let accesses = [];
    for (const item of dashboard_features) {
      const accessx = {
        name: item,
        can_view: false,
        can_create: false,
        can_update: false,
        can_delete: false,
      };
      accesses.push(accessx);
    }
    for (const item of alert_features) {
      const accessx = {
        name: item,
        can_view: false,
        can_create: false,
        can_update: false,
        can_delete: false,
      };
      accesses.push(accessx);
    }
    const accessx = {
      name: "MACHINE PROFILES",
      can_view: false,
      can_create: false,
      can_update: false,
      can_delete: false,
    };
    accesses.push(accessx);
    const access_gina = {
      name: "GINA Feature",
      can_view: false,
      can_create: false,
      can_update: false,
      can_delete: false,
    };
    accesses.push(access_gina);
    return accesses;
  }

  async function getFeatureAccess() {
    const access = emptyFeatureAccess();
    const extendedAccess = customPermissions.map(cp => {
      return {
        name: cp.page_name,
        can_view: false,
        can_create: false,
        can_update: false,
        can_delete: false,
      };
    });
    const allAccess = [...access, ...extendedAccess];
    setUserRoleFeatureAccess(allAccess);

    // Initialize checkbox states
    const initialCheckboxStates = {};
    access.forEach(ac => {
      ['view', 'create', 'update', 'delete'].forEach(type => {
        const key = `${ac.name}-${type}`;
        initialCheckboxStates[key] = ac[`can_${type}`];
      });
    });
    setCheckboxStates(initialCheckboxStates);
  }

  const isAccessSelected = useCallback((item, type) => {
    // First check if we have a specific checkbox state
    const checkboxKey = `${item}-${type}`;
    if (checkboxStates[checkboxKey] !== undefined) {
      return checkboxStates[checkboxKey];
    }

    // Fallback to checking the userRoleFeatureAccess
    const result = userRoleFeatureAccess.some(
      (sv) => sv.name === item && sv["can_" + type] === true
    );
    return result;
  }, [userRoleFeatureAccess, checkboxStates]);

  const handleStatusChange = (e) => {
    const value = e.target.value;
    setStatus(value);
  };

  function handleSelectAccess(item, type) {

    // Update the main state
    setUserRoleFeatureAccess(prev => {
      const newState = prev.map(ac => {
        if (ac.name === item) {
          const newValue = !ac["can_" + type];
          return {
            ...ac,
            ["can_" + type]: newValue
          };
        }
        return ac;
      });
      return newState;
    });

    // Update checkbox states directly
    const checkboxKey = `${item}-${type}`;
    setCheckboxStates(prev => ({
      ...prev,
      [checkboxKey]: !prev[checkboxKey]
    }));

    // Force re-render by updating render key
    setRenderKey(prev => prev + 1);
  }

  useEffect(() => {
    getFeatureAccess();
  }, [customPermissions]);

  useEffect(() => {
    // Start with empty feature access as base
    const baseAccess = emptyFeatureAccess();
    const extendedAccess = customPermissions.map(cp => {
      return {
        name: cp.page_name,
        can_view: false,
        can_create: false,
        can_update: false,
        can_delete: false,
      };
    });
    const allAccess = [...baseAccess, ...extendedAccess];
    if (row) {
      setName(row.rolename);
      setSelectedLocations(row.accesses ? row.accesses : []);
      var n = row.accesses ? row.accesses.length : 0;

      for (var i = 0; i < n; i++) {
        const acc = row.accesses[i];
      }
      setStatus(row.is_active === true ? 1 : 0);

      if (row.roleFeatureAccess && row.roleFeatureAccess.length > 0) {
        // Create a map of existing permissions for quick lookup
        const permissionMap = {};
        row.roleFeatureAccess.forEach(acc => {
          permissionMap[acc.page_name] = {
            can_view: acc.can_view,
            can_create: acc.can_create,
            can_update: acc.can_update,
            can_delete: acc.can_delete,
          };
        });

        // Update base access with actual permissions
        const updatedAccess = allAccess.map(feature => {
          const permissions = permissionMap[feature.name];
          if (permissions) {
            return {
              ...feature,
              can_view: permissions.can_view,
              can_create: permissions.can_create,
              can_update: permissions.can_update,
              can_delete: permissions.can_delete,
            };
          }
          return feature; // Keep default false values if no permissions found
        });

        setUserRoleFeatureAccess(updatedAccess);

        // Update checkbox states to reflect the loaded permissions
        const newCheckboxStates = {};
        updatedAccess.forEach(ac => {
          ['view', 'create', 'update', 'delete'].forEach(type => {
            const key = `${ac.name}-${type}`;
            newCheckboxStates[key] = ac[`can_${type}`];
          });
        });
        setCheckboxStates(newCheckboxStates);

        setOverviewPage(row.overview_page);
      } else {
        setUserRoleFeatureAccess(allAccess);
      }
    } else {
      setName("");
      setStatus("");
      setOverviewPage("admin");
      setSelectedLocations([]);
      setUserRoleFeatureAccess(allAccess);
    }
  }, [row, customPermissions]);

  const handleSelectLocation = (id) => {
    if (selectedLocations.includes(id)) {
      setSelectedLocations((values) => values.filter((v) => v !== id));
    } else {
      setSelectedLocations((values) => [...values, id]);
    }
  };

  const isSelectedLocation = (id) => {
    return selectedLocations.includes(id);
  };

  const renderLocations = (locations) => {
    return (
      <>
        {locations.map((location, index) => {
          return (
            <div key={index}>
              <div
                className="form-check"
                onClick={() => handleSelectLocation(location.id)}
              >
                <input
                  className="form-check-input"
                  checked={isSelectedLocation(location.id)}
                  type="checkbox"
                  id={`${location.id}`}
                />
                <label className="form-check-label" htmlFor={location.id}>
                  {location.location_name}
                </label>
              </div>
              {location.sublocations && location.sublocations.length > 0 && (
                <div style={{ marginLeft: "20px" }}>
                  {renderLocations(location.sublocations)}
                </div>
              )}
            </div>
          );
        })}
      </>
    );
  };

  const selectPermission = (key, p) => {
    if (selectedPermissions.find((sp) => sp.name == p.key)) {
      const selected = [...selectedPermissions].filter((sp) => sp.id !== p.id);
      setSelectedPermissions(selected);
    } else {
      setSelectedPermissions((prev) => [...prev, p]);
    }
  };

  const isPermissionSelected = (p) => {
    if (selectedPermissions.find((sp) => sp.id == p.id)) {
      return true;
    } else {
      return false;
    }
  };
  return (
    <ConfirmationDlg
      open={open}
      size={"lg"}
      btnCancelText="Cancel"
      btnSubmitText={"Submit"}
      onSubmit={handleSubmit}
      onClose={handleClose}
    >
      <div className="my-2">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            m: "auto",
          }}
        >
          <div style={{ px: 5, py: 4 }}>
            <NormalInput
              onchange={(e) => {
                setName(e.target.value);
              }}
              required
              type="text"
              value={name}
              label={"Name"}
            />

            <Card>
              <CardHeader>Location Access</CardHeader>
              <CardBody>
                <div>{renderLocations(locations)}</div>
              </CardBody>
            </Card>

            <Card className="my-2">
              <CardHeader>Permissions</CardHeader>
              <CardBody>
                <div className="d-flex row">
                  {["view", "create", "update", "delete"].map((key, index) => {
                    return (
                      <div key={key} className="col-md-6">
                        <div
                          style={{
                            fontWeight: "bold",
                            textTransform: "capitalize",
                            marginBottom: 5,
                          }}
                        >
                          {" "}
                          {key}
                        </div>

                        {userRoleFeatureAccess.map((v, i) => {
                          const checkboxKey = `${v.name}-${key}`;
                          const isChecked = checkboxStates[checkboxKey] !== undefined
                            ? checkboxStates[checkboxKey]
                            : isAccessSelected(v.name, key);
                          const uniqueId = `${v.name}-${key}-${i}`;
                          return (
                            <div key={uniqueId} className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={uniqueId}
                                checked={isChecked}
                                onChange={(e) => {
                                  handleSelectAccess(v.name, key);
                                }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={uniqueId}
                                style={{ textTransform: "capitalize" }}
                              >
                                {v.name}
                              </label>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
              </CardBody>
            </Card>

            <Card className="my-2">
              <CardHeader>Overview Page</CardHeader>
              <CardBody>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="flexRadioDefault1"
                    checked={overviewPage == "admin"}
                    onChange={() => setOverviewPage("admin")}
                  />
                  <label class="form-check-label" for="flexRadioDefault1">
                    Admin
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="flexRadioDefault2"
                    checked={overviewPage == "engineer"}
                    onChange={() => setOverviewPage("engineer")}
                  />
                  <label class="form-check-label" for="flexRadioDefault2">
                    Engineer
                  </label>
                </div>
              </CardBody>
            </Card>

            <div
              style={{ marginTop: "20px", display: "none" }}
              className={"row mx-2"}
            >
              <div className="col-sm-3">Features Access Permission</div>
              <div className="col-sm-9 border-theme border">
                <table className="table table-bordered table-sm">
                  <thead>
                    <th></th>
                    <th width={"60"}>View</th>
                    <th width={"60"}>Create</th>
                    <th width={"60"}>Update</th>
                    <th width={"60"}>Delete</th>
                  </thead>
                  <tbody>
                    <tr>
                      <td width="170" colSpan={5}>
                        DASHBOARD
                      </td>
                    </tr>
                    {dashboard_features.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{item}</td>
                          <td align="center">
                            <div
                              className="form-check"
                              onClick={() => handleSelectAccess(item, "view")}
                            >
                              <input
                                className="form-check-input"
                                checked={isAccessSelected(item, "view")}
                                onChange={() => {}}
                                type="checkbox"
                              />
                            </div>
                          </td>
                          <td align="center">
                            <div
                              className="form-check"
                              onClick={() => handleSelectAccess(item, "create")}
                            >
                              <input
                                disabled={true}
                                className="form-check-input"
                                onChange={() => {}}
                                checked={isAccessSelected(item, "create")}
                                type="checkbox"
                              />
                            </div>
                          </td>
                          <td align="center">
                            <div
                              className="form-check"
                              onClick={() => handleSelectAccess(item, "update")}
                            >
                              <input
                                disabled={true}
                                className="form-check-input"
                                onChange={() => {}}
                                checked={isAccessSelected(item, "update")}
                                type="checkbox"
                              />
                            </div>
                          </td>
                          <td align="center">
                            <div
                              className="form-check"
                              onClick={() => handleSelectAccess(item, "delete")}
                            >
                              <input
                                disabled={true}
                                className="form-check-input"
                                onChange={() => {}}
                                checked={isAccessSelected(item, "delete")}
                                type="checkbox"
                              />
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td colSpan="5"></td>
                    </tr>
                    <tr>
                      <td colSpan={5}>ALERTS</td>
                    </tr>
                    {alert_features.map((item) => {
                      return (
                        <tr>
                          <td>{item}</td>
                          <td align="center">
                            <div
                              className="form-check"
                              onClick={() => handleSelectAccess(item, "view")}
                            >
                              <input
                                disabled={true}
                                className="form-check-input"
                                onChange={() => {}}
                                checked={isAccessSelected(item, "view")}
                                type="checkbox"
                              />
                            </div>
                          </td>
                          <td align="center">
                            <div
                              className="form-check"
                              onClick={() => handleSelectAccess(item, "create")}
                            >
                              <input
                                disabled={
                                  item == "Alert Details" ||
                                  item == "Alert Count"
                                }
                                className="form-check-input"
                                onChange={() => {}}
                                checked={isAccessSelected(item, "create")}
                                type="checkbox"
                              />
                            </div>
                          </td>
                          <td align="center">
                            <div
                              className="form-check"
                              onClick={() => handleSelectAccess(item, "update")}
                            >
                              <input
                                disabled={item == "Alert Count"}
                                className="form-check-input"
                                onChange={() => {}}
                                checked={isAccessSelected(item, "update")}
                                type="checkbox"
                              />
                            </div>
                          </td>
                          <td align="center">
                            <div
                              className="form-check"
                              onClick={() => handleSelectAccess(item, "delete")}
                            >
                              <input
                                disabled={
                                  item == "Alert Details" ||
                                  item == "Alert Count"
                                }
                                className="form-check-input"
                                onChange={() => {}}
                                checked={isAccessSelected(item, "delete")}
                                type="checkbox"
                              />
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td colSpan="5"></td>
                    </tr>
                    <tr>
                      <td>Machine Profiles</td>
                      <td align="center">
                        <div
                          className="form-check"
                          onClick={() => handleSelectAccess(MPitem, "view")}
                        >
                          <input
                            className="form-check-input"
                            onChange={() => {}}
                            checked={isAccessSelected(MPitem, "view")}
                            type="checkbox"
                          />
                        </div>
                      </td>
                      <td align="center">
                        <div
                          className="form-check"
                          onClick={() => handleSelectAccess(MPitem, "create")}
                        >
                          <input
                            className="form-check-input"
                            onChange={() => {}}
                            checked={isAccessSelected(MPitem, "create")}
                            type="checkbox"
                          />
                        </div>
                      </td>
                      <td align="center">
                        <div
                          className="form-check"
                          onClick={() => handleSelectAccess(MPitem, "update")}
                        >
                          <input
                            className="form-check-input"
                            onChange={() => {}}
                            checked={isAccessSelected(MPitem, "update")}
                            type="checkbox"
                          />
                        </div>
                      </td>
                      <td align="center">
                        <div
                          className="form-check"
                          onClick={() => handleSelectAccess(MPitem, "delete")}
                        >
                          <input
                            className="form-check-input"
                            onChange={() => {}}
                            checked={isAccessSelected(MPitem, "delete")}
                            type="checkbox"
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Gina Features</td>
                      <td align="center">
                        <div
                          className="form-check"
                          onClick={() => handleSelectAccess(Gina, "view")}
                        >
                          <input
                            className="form-check-input"
                            onChange={() => {}}
                            checked={isAccessSelected(Gina, "view")}
                            type="checkbox"
                          />
                        </div>
                      </td>
                      <td align="center">
                        <div
                          className="form-check"
                          onClick={() => handleSelectAccess(Gina, "create")}
                        >
                          <input
                            className="form-check-input"
                            disabled={true}
                            onChange={() => {}}
                            checked={isAccessSelected(Gina, "create")}
                            type="checkbox"
                          />
                        </div>
                      </td>
                      <td align="center">
                        <div
                          className="form-check"
                          onClick={() => handleSelectAccess(Gina, "create")}
                        >
                          <input
                            className="form-check-input"
                            disabled={true}
                            onChange={() => {}}
                            checked={isAccessSelected(Gina, "create")}
                            type="checkbox"
                          />
                        </div>
                      </td>
                      <td align="center">
                        <div
                          className="form-check"
                          onClick={() => handleSelectAccess(Gina, "create")}
                        >
                          <input
                            className="form-check-input"
                            disabled={true}
                            onChange={() => {}}
                            checked={isAccessSelected(Gina, "create")}
                            type="checkbox"
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div style={{ mt: 0, mb: 4, display: "none" }} className={"row"}>
              <div className="col-sm-3">Status</div>
              <div className="col-sm-9">
                <div className="form-control">
                  <label>Status</label>
                  <select value={status} onChange={handleStatusChange}>
                    <option value="">- Select Status -</option>
                    <option value="1">Active</option>
                    <option value="2">InActive</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ConfirmationDlg>
  );
}

export default ModalChangeRole;
